import React, {FC} from "react";
import {Box} from "@mui/material";
import i18n from "i18next";
import {Typography, TextField as MuiTextField} from "@material-ui/core";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {removeSuffix} from "../../../../../../../../../../../../utils/functions";

const Title = styled(Typography)`
  color: white;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
`

const TextField = styled(MuiTextField)`
  background-color: #233145;
  width: 100%;
  & .MuiOutlinedInput-input {
    padding: 12.5px 14px;
  }
`

type PropsType = {
  title: string
  type: string
  onHandleChange: (field: string, value: any, willClearField?: string | undefined) => void
  value: string
  field: string
}

const InputBlock: FC<PropsType> = ({
  title,
  type,
  onHandleChange,
  value,
  field
                                   }) => {
  const { t } = useTranslation()

  const namesLanguages: { [key: string]: any } = {
    en: t("LanguagesDropdown_English"),
    sv: t("LanguagesDropdown_Swedish"),
    da: t("LanguagesDropdown_Danish")
  }

  return (
    <React.Fragment>
      <Box my={2} display={'flex'}>
        <Title>{t(title)}</Title>
      </Box>
      <TextField
        type={type}
        variant={'outlined'}
        placeholder={`${t('please_write_the_text_in')} ${namesLanguages[removeSuffix(i18n.language)]}`}
        onChange={(e) => onHandleChange(field, e.target.value)}
        value={value}
        InputLabelProps={{shrink: false}}
      />
    </React.Fragment>
  )
}

export default InputBlock